<template>
  <div>
    <div class="title">
      解决方案管理
    </div>
    <div class="content">
      <div class="pageList">
        <button class="addBtn" @click="addPlan">发布解决方案 + </button>
        <div class="list">
          <template v-if="list.length">
          <!--新数据开始-->
            <div class="listItem2" v-for="item in list" :key="item.id">
              <div class="leftMsg">
                <img class="thumb" @click="lookBigImg(baseUrl + item.solutionAppImage)" :src="baseUrl + item.subImage" />
                <div>
                  <div>
                    <span class="title">{{item.topTitle}}</span>
                    <template v-if="item.approveStatus === 0">
                      <span class="status status0">审核中</span>
                    </template>
                    <template v-if="item.approveStatus === 1">
                      <span class="status status1">通过</span>
                    </template>
                    <template v-if="item.approveStatus === 2">
                      <span class="status status2">不通过</span>
                    </template>
                  </div>
                  <div>
                    <span class="msgItem"><span class="label">创建时间</span>{{item.createTime}}</span>
                    <span class="msgItem"><span class="label" v-if="item.approveTime">审核时间</span>{{item.approveTime}}</span>
                  </div>
                </div>
              </div>
              <div class="btns">
                <button class="btn1" v-if="item.approveStatus === 1" @click="toDetails(item.id)">查看</button>
                <button class="btn2" @click="editPlan(item)">编辑</button>
                <button class="btn3" @click="handleDelPlan(item.id)">删除</button>
              </div>
            </div>
            <!--新数据结束-->
          </template>
          <template v-else>
            <Nodata />
          </template>
        </div>
        <div class="pageBox">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--查看大图-->
    <div class="bigImgBox" v-show="bigVisible">
      <div class="imgBox">
        <img class="bigImg" :src="bigImgUrl" />
      </div>
      <img class="closeImg" src="../../assets/images/delIcon.png" @click="closeBigImg" />
    </div>

    <!--编辑弹窗-->
    <SolveDialog ref="solveDialog" @getList="refresh"></SolveDialog>

    <!--查看详情弹窗-->
    <SolveDetailDialog ref="solveDetailDialog"></SolveDetailDialog>
  </div>
</template>

<script>
  import { fetchPlanList, fetchPlanDelete } from '@/api/api'
  import SolveDialog from './components/SolveDialog'
  import SolveDetailDialog from './components/SolveDetailDialog'
  import {
    serverUrl
  } from '@/utils/server.js'
  import Nodata from '@/components/noData.vue'
  export default {
    data() {
      return {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        bigImgUrl:'',
        bigVisible: false,
        list: [],
        loading: false,
        baseUrl: serverUrl.baseURL,
      }
    },
    components: {
      SolveDialog,
      SolveDetailDialog,
      Nodata
    },
    created() {
      this.getList()
    },
    methods: {
      refresh() {
        this.pageNum = 1
        this.getList()
      },
      toDetails(val) {
        // this.$router.push({
        //   path: "/DetailsPage",
        //   query: {
        //     data: val
        //   },
        // })
        this.$refs.solveDetailDialog.openDialog(val)
      },
      handleDelPlan(id) {
        let params = {
          ids: [id]
        }
        fetchPlanDelete(params).then(res => {
          if(res.code == 1) {
              this.$message.success('删除成功');
              this.getList()
            }else {
              this.$message.error('删除失败');
            }
        })
      },
      closeBigImg() {
       this.bigVisible=false
      },
      lookBigImg(src) {
        this.bigImgUrl = src
        this.bigVisible = true
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageNum = val
        this.getList()
      },
      getList() {
        let params = {
          page: this.pageNum - 1,
          size: this.pageSize
        }
        fetchPlanList(params).then(res => {
          this.list = res.data.content
          this.total = Number(res.data.totalElements)
        })
      },
      editPlan(data) {
        this.$refs.solveDialog.openDialog(data)
      },
      addPlan() {
        this.$refs.solveDialog.openDialog()
      }
    }
  }
</script>

<style scoped>
  .title {
    height: 66px;
    line-height: 66px;
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #282F3D;
    padding-left: 30px;
    background: #fff;
  }

  .content {
    box-sizing: border-box;
    padding: 10px 20px;
  }

  .pageList {
    width: 100%;
    height: calc(100vh - 180px);
    background: #FFFFFF;
    box-shadow: 1px 3px 16px 0px rgba(204, 211, 228, 0.51);
    border-radius: 8px;
    box-sizing: border-box;
    padding: 20px 40px;
    /* border: 1px solid #f00; */
  }

  .listItem {
    padding: 10px 0;
    border-bottom: 1px solid #E8EBF4;
    position: relative;
  }

  .status {
    background: rgba(34,94,253,0.1);
    border: 1px solid #225EFD;
    border-radius: 22px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #225EFD;
    text-align: center;
    padding: 3px 15px;
    margin-left: 10px;
  }
  .status0{

  }
  .status1{
    background: rgba(13,193,110,0.1);
    color: #29C87E;
    border: 1px solid #0DC16E;
  }
  .status2{
    background: rgba(255,111,5,0.1);
    color: #FF8D3A;
    border: 1px solid #FF8D3A;
  }

  .pageTitle {
    padding: 15px 0;
  }

  .pageContent {
    padding: 15px 0 0;
    display: flex;
    justify-content: flex-start;
  }

  .pageContent > div {
    width: 30%;
    align-items: flex-start;
    display: flex;
  }

  .pageBox{
    display: flex;
    justify-content: flex-end;
  }
  .list{
    height: calc(100vh - 280px);
    overflow-y: scroll;
  }
  .list::-webkit-scrollbar{
    width: 0!important;
  }
  .label{
    color: #909DB1;
    padding-right: 20px;
    min-width: 80px;
  }

    .btn {
    width: 135px;
    height: 43px;
    border: 1px solid #0F5EFF;
    border-radius: 21px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0px;
    bottom: 20px;
    cursor: pointer;

  }
  .btn a {
    display: block;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .btn img {
    margin-top: 3px;
    margin-left: 5px;
    /* width: 18px;
    height: 9px; */
  }

  .btn  div {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    text-align: center;
    /* line-height: 43px; */
  }
  .pageContent > div.oneItem{
    width: 100%;
    display: flex;
    align-items: flex-start;
  }
  .thumbnail{
    width: 200px;
  }
  .bigImgBox{
    position: fixed;
    top: 0;
    left:0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .bigImgBox img.bigImg {
    width: 95%;
    max-height: 100vh;
  }
  .bigImgBox .closeImg{
    width: 50px;
    cursor: pointer;
    position: absolute;
    right: 5%;
    top: 10px;
  }
  .imgBox{
    background: #fff;
  }

  .addBtn{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #FFFFFF;
    background: #2050D1;
    border-radius: 25px;
    cursor: pointer;
    padding: 8px 30px;
    outline: none;
    border: none;
  }
  .listItem2 .title{
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    padding: 0;
  }
  .listItem2 .thumb{
    width: 205px;
    height: 110px;
    margin-right: 16px;
  }

.listItem2{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #E8EBF4;
  padding: 30px 0 45px;
}
.leftMsg{
  flex: 1;
  display: flex;
  /* align-items: center; */
}
.leftMsg .msgItem{
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #121E30;
  margin-right: 80px;
}
.msgItem span.label{
  color: #909DB1;
}
  .btns{
  }
  .btns button {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #0F5EFF;
    padding: 8px 25px;
    outline: none;
    cursor: pointer;
    border: 1px solid #0F5EFF;
    background: #fff;
    border-radius: 21px;
  }
  .btns .btn1{
    color: #0F5EFF;
    border: 1px solid #0F5EFF;
  }
  .btns .btn2{
    color: #53CA94;
    border: 1px solid #179D5F;
  }
  .btns .btn3{
    color: #808080;
    border: 1px solid #808080;
  }


</style>



// WEBPACK FOOTER //
// src/views/console/SolvePlan.vue